/**
 * An answer's video evidence, looked up across the whole document by the
 * interaction that produced it, so a page with several conversations finds it
 * without knowing which one it belongs to.
 */
const findVideoEvidence = (interactionId: string) =>
	document.querySelector<HTMLElement>(
		`section[data-type="video-evidence"][data-interaction-id="${interactionId}"]`,
	);

export const scrollVideoEvidenceOffView = (
	interactionId: string,
	offset = 0,
): boolean => {
	const videoEvidence = findVideoEvidence(interactionId);
	if (videoEvidence) {
		const precedingElement = videoEvidence.previousElementSibling;
		if (precedingElement) {
			const y =
				precedingElement.getBoundingClientRect().bottom +
				window.scrollY -
				window.innerHeight +
				offset;
			window.scrollTo({ top: y, behavior: "smooth" });
		}
		return true;
	}
	return false;
};

export const hideVideoEvidence = (interactionId: string) => {
	findVideoEvidence(interactionId)?.classList.add("video-evidence-hidden");
};

export const showVideoEvidence = (interactionId: string) => {
	findVideoEvidence(interactionId)?.classList.remove("video-evidence-hidden");
};
